module.exports = __webpack_public_path__ + "img/four.88be11d5.png";